<template>
  <div class="主要任務內容">
    <div class="主要任務內容__58e17526a8d4493fa92a09b52f20f341 headline">
      1. 促進、鼓勵及改善所有血管疾病健康知識的傳遞，並教育所有大眾血管疾病的保健及照顧。 <br />2.
      提供血管外科醫師對於新的手術技術以及知識的教育。 <br />3.
      做為所有會員在血管外科所有領域，包括血管內手術的支持組織。 <br />4. 促進改善血管疾病病人的診斷及治療。 <br />5.
      清楚的定位出外科手術、血管內手術、以及藥物治療對於血管疾病的治療與預防。 <br />6. 鼓勵血管疾病的臨床及基礎研究。
      <br />7. 鼓勵對於血管疾病診斷及治療上新技術的發展及執行，並協助建立血管診察室。 <br />8.
      審議有關血管疾病命名及標準，並協助政府與民間制定血管疾病之政策及方案。 <br />9.
      規範血管外科有關的社會倫理及法律事項。 <br />10. 提供對血管外科有興趣的外科醫師專門的訓練。 <br />11.
      舉辦學術演講及討論。 <br />12. 編輯會訊及有關書刊。 <br />13.
      甄審血管外科醫師、血管外科專科指導醫師,以及評鑑培訓血管外科醫師教學醫院，並有頒發證書之資格。 <br />14.
      獎助血管外科人才及舉辦其他有關事宜。
    </div>
  </div>
</template>

<script>
export default {
  name: "Mission"
};
</script>

<style lang="scss">
.主要任務內容 {
  &__58e17526a8d4493fa92a09b52f20f341 {
    line-height: (38 / 23);
    color: #121a33;
  }
}
</style>
